import React from 'react'
import { Link } from 'react-router-dom'
import { FiArrowRight, FiGithub, FiZap, FiEye, FiCode } from 'react-icons/fi'
import logo from '../resources/logo_128x128.png'
import YoutubeResponsive from './features/video/YoutubeResponsive'
import PoweredBy from './features/documentation/PoweredBy'
import '../styles/style.css'

const REPOSITORY_URL = 'https://github.com/BraisIglesias17/NeuroRules.git'

export default function Home() {
  return (
    <div className="page home-page">
      <section className="hero">
        <div className="hero-copy">
          <div className="eyebrow"><span className="status-dot" /> Explainable AI, made practical</div>
          <h1>Turn complex data into <span>human-readable rules.</span></h1>
          <p className="hero-lead">Neurorule brings data preparation, analysis, machine learning and neuro-fuzzy rule generation into one approachable desktop workspace.</p>
          <div className="hero-actions">
            <Link className="button button-primary" to="/download">Download for Windows <FiArrowRight /></Link>
            <a className="button button-secondary" href={REPOSITORY_URL} target="_blank" rel="noopener noreferrer"><FiGithub /> View on GitHub</a>
          </div>
          <p className="open-note"><FiCode /> Open source and built for transparent research workflows.</p>
        </div>
        <div className="hero-visual" aria-hidden="true"><div className="orb orb-one" /><div className="orb orb-two" /><div className="brain-card"><img src={logo} alt="" /><span>IF temperature is high</span><span>AND pressure is low</span><strong>THEN output is optimal</strong><small>Confidence · 0.91</small></div></div>
      </section>
      <section className="feature-grid" aria-label="Neurorule benefits">
        <Feature icon={<FiZap />} title="From data to insight" text="Clean, preprocess, visualize and model your data without stitching together separate tools." />
        <Feature icon={<FiEye />} title="Designed to explain" text="Generate intelligible rules that make model behavior easier to interpret and communicate." />
        <Feature icon={<FiCode />} title="No coding required" text="A visual workflow helps researchers focus on their domain, not on implementation details." />
      </section>
      <section className="content-section split-section">
        <div><div className="section-label">Built for discovery</div><h2>Serious analysis without the steep learning curve.</h2><p>From plant biology and pharmaceutical research to operational optimization, Neurorule helps professionals explore data and make informed decisions while keeping the reasoning visible.</p><Link className="text-link" to="/documentation">Explore the workflow <FiArrowRight /></Link></div>
        <div className="use-case-card"><span>01</span><p>Prepare and inspect your dataset</p><span>02</span><p>Train proven machine-learning models</p><span>03</span><p>Generate interpretable neuro-fuzzy rules</p></div>
      </section>
      <section className="content-section video-section"><div className="section-label">See it in action</div><h2>A guided tour of Neurorule</h2><p>Watch the software tutorial and move from raw data to useful results.</p><YoutubeResponsive /></section>
      <PoweredBy />
    </div>
  )
}

function Feature({ icon, title, text }) {
  return <article className="feature-card"><span className="feature-icon">{icon}</span><h3>{title}</h3><p>{text}</p></article>
}
